import Logo from './Logo'
import MobileNav from './MobileNav'
import Search from './Search'
import CtaDropDown from './CTA'
import MainNav from './MainNav'

function Header(props) {
  return (
    <header className={`bg-base relative`}>
      {props.children}
      <div className="container mx-auto h-full flex justify-between no-wrap items-stretch px-2 sm:px-0">
        <Logo deskLogo={props.deskLogo} mobLogo={props.mobLogo} />
        {!props.res.hideMegamenu && <MainNav {...props} nav={props.nav} type="desktop" />}
        {props.contactUsCta && <CtaDropDown fn="contact" {...props} ctas={[props.contactUsCta]} type={'button'} variant="divider" isFirst={true} />}
        {props.ctas && <CtaDropDown fn="utility" {...props} type={'button'} variant="divider" isFirst={!props.contactUsCta} />}
        <Search {...props} />
        {!props.res.hideMegamenu && <MobileNav {...props} nav={props.nav} type="mobile" />}
      </div>
    </header>
  )
}

export default Header
